(function () {
  function pad2(n) {
    return String(Math.max(0, Math.min(99, n))).padStart(2, '0');
  }

  function headlineOverlapsTimer(headline, timer) {
    var headlineRect = headline.getBoundingClientRect();
    var timerRect = timer.getBoundingClientRect();
    var sameRow = Math.abs(headlineRect.top - timerRect.top) <= 4;
    return sameRow && headlineRect.right > timerRect.left + 0.5;
  }

  function updateRowStack(banner) {
    var headline = banner.querySelector('.product-promo-countdown-banner__headline');
    var timer = banner.querySelector('.product-promo-countdown-banner__timer');
    if (!headline || !timer || timer.hidden || banner.hidden) {
      banner.classList.remove('product-promo-countdown-banner--row-stack');
      return;
    }

    banner.classList.remove('product-promo-countdown-banner--row-stack');
    if (headlineOverlapsTimer(headline, timer)) {
      banner.classList.add('product-promo-countdown-banner--row-stack');
    }
  }

  function initRowStackLayout(banner, scheduleUpdate) {
    if (banner.dataset.rowStackInit) return;
    banner.dataset.rowStackInit = 'true';

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(scheduleUpdate);
      ro.observe(banner);
      var grid = banner.querySelector('.product-promo-countdown-banner__grid');
      if (grid) ro.observe(grid);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleUpdate);
    }
  }

  function bind(el) {
    if (el.dataset.countdownBound) return;
    el.dataset.countdownBound = 'true';

    var rafId = null;
    function scheduleRowStackUpdate() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function () {
        rafId = null;
        updateRowStack(el);
      });
    }

    initRowStackLayout(el, scheduleRowStackUpdate);
    window.addEventListener('resize', scheduleRowStackUpdate);

    // Server-authoritative: `data-remaining` is the number of seconds left,
    // computed in Liquid. The client never reads its own wall clock as an
    // absolute value — it only measures elapsed local time (a duration) via
    // performance.now(), so a wrong or manipulated device clock can't
    // produce a false countdown.
    var total = parseInt(el.dataset.remaining, 10);
    if (!Number.isFinite(total) || total <= 0) {
      el.hidden = true;
      scheduleRowStackUpdate();
      return;
    }
    var startedAt = performance.now();
    var intervalId = null;
    // Without seconds the display only changes once a minute, so only touch the
    // DOM when it actually does. The interval stays at 1s so expiry is still
    // caught promptly, but this stops a forced layout (scheduleRowStackUpdate)
    // every second and stops the aria-live digits region announcing on every
    // tick to screen readers.
    var lastRendered = null;

    var dEl = el.querySelector('[data-product-promo-countdown-d]');
    var hEl = el.querySelector('[data-product-promo-countdown-h]');
    var mEl = el.querySelector('[data-product-promo-countdown-m]');

    function tick() {
      var elapsed = Math.floor((performance.now() - startedAt) / 1000);
      var remaining = total - elapsed;
      if (remaining <= 0) {
        el.hidden = true;
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
        scheduleRowStackUpdate();
        return;
      }
      var days = Math.floor(remaining / (60 * 60 * 24));
      var hours = Math.floor((remaining % (60 * 60 * 24)) / (60 * 60));
      var mins = Math.floor((remaining % (60 * 60)) / 60);
      var stamp = days + ':' + hours + ':' + mins;
      if (stamp === lastRendered) return;
      lastRendered = stamp;
      if (dEl)
        dEl.textContent = days > 99 ? String(days) : String(Math.max(0, days)).padStart(2, '0');
      if (hEl) hEl.textContent = pad2(hours);
      if (mEl) mEl.textContent = pad2(mins);
      el.hidden = false;
      scheduleRowStackUpdate();
    }

    tick();
    intervalId = setInterval(tick, 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-product-promo-countdown]').forEach(bind);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);

  // Discount code chip: copies the code and briefly swaps the icon for a check.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-promo-banner-copy]');
    if (!button || !navigator.clipboard) return;
    navigator.clipboard.writeText(button.dataset.promoBannerCopy).then(function () {
      button.classList.add('is-copied');
      setTimeout(function () {
        button.classList.remove('is-copied');
      }, 2000);
    });
  });
})();
